<template>
  <div class="about">
    <Header headertext="About" />
    
    <h2>コンタクト</h2>
    <a href="mailto:ambiesoft.trueff@gmail.com">e-mail</a>
  </div>
</template>

<script>
import Header from "@/components/Header.vue"

export default {
  name: "links",
  components: {
    Header,
  },  
}
</script>

<style>
.about {
  text-align:center;
}
#error {
  color:red;
}
</style>